export default "__VITE_ASSET__DYOLzcrw__"